import selectableColumnType from "@harbor/elements/utils/table/columnTypes/selectable";
import { generatePath } from "react-router-dom";
import { tableCellSelection, tableColumnSelection } from "../../../../common/adUtils";
import { routeURLs } from "../../../../../../../../utils/enums";
import { tViews } from "../../../../../../../../utils/table";

const getColumns = ({ store, openTableSettings }) => {
    return [
        {
          id: "selectable_col",
          headerSlot: false,
          hiddenText: "Select all",
          ...selectableColumnType({
            testId: (props) => `checkbox-${props.model.id}`,
            store,
            ariaLabel: (props) => tViews('selectApplication', {item: props.model.application}),
          }),
          columnTemplate: (createElement) => {
            return tableColumnSelection(createElement, store);
          },
          cellTemplate: (createElement, props) => {
            return tableCellSelection(createElement, props, store);
          }
        },
        { id: "application_col",
          prop: "application",
          name: tViews('usageAppTable.column_label.ApplicationName'),
          sortable: true,
          size: 300,
          cellTemplate: (createElement, prop) => {
            return createElement("hbr-link", 
            {
              "onClick": (e) => {
                e.preventDefault();
                window.location.href = generatePath(routeURLs.app360, { appName: prop.model.application });
              },
              "aria-label": tViews('applicationDetailswithName', {itemname :prop.model.application}),
              "data-testid":"usage-application-link",
              role: "link",
              "onKeyDown": (e) => {
                // Trigger action on Enter or Space key
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  window.location.href = generatePath(routeURLs.app360, { appName: prop.model.application });
                }
              },
            }, prop.model.application);
          }
        },
        { id: "application_family_long_name_col",
          prop: "application_family_long_name",
          name: tViews('usageAppTable.column_label.AppFamily'),
          sortable: true,
          size: 300
        },
        { id: "display_usage_col",
          prop: "display_usage",
          name: tViews('usageAppTable.column_label.Usage'),
          sortable: true,
          size: 300
        },
        {
          id: "actions_col",
          prop: "actions",
          name: "Actions",
          hiddenText: "Actions",
          disableToggle: true,
          sortable: false,
          headerSlot: false,
          pin: "colPinEnd",
          size: 70,
          columnTemplate: (createElement) => {
            return createElement("hbr-icon-button", {
              name: "gear-six-outlined",
              class: "hbr-css__table-cell-align-center gear-icon",
              aria: { label: tViews('tableSettings') || "Table settings" },
              "data-testid": "setting-ad-app-table",
              onClick: (evt) => {
                evt.stopPropagation();
                openTableSettings();
              }
            });
          }
        }
    ]
}

export default getColumns;
